var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticStyle: { cursor: "pointer" }, on: { click: _vm.openDictTable } },
    [
      _c(
        "tooltip",
        _vm._b(
          {
            ref: "tooltip",
            attrs: {
              "api-code": _vm.apiCode,
              "primary-key": _vm.primaryKey,
              disabled: _vm.disabled,
              effect: _vm.effect,
              content: _vm.content,
              placement: _vm.placement,
            },
          },
          "tooltip",
          _vm.$attrs,
          false
        ),
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.drawerRendered
        ? _c(
            "dg-drawer",
            {
              attrs: {
                title: "提示管理",
                visible: _vm.drawer,
                "append-to-body": "",
                "wrapper-closable": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawer = $event
                },
                confirm: _vm.submitData,
              },
            },
            [
              _vm.drawer
                ? _c("dg-form", {
                    ref: "tooltipForm",
                    attrs: {
                      "form-data": _vm.formData,
                      rules: _vm.rules,
                      "form-items": _vm.formItems,
                      "label-position": "top",
                    },
                    on: {
                      "update:formData": function ($event) {
                        _vm.formData = $event
                      },
                      "update:form-data": function ($event) {
                        _vm.formData = $event
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }